import React, { useState, useEffect } from "react";
import TutoringCard from './tutoringTeamCard'; 

import "./style/statsCarousel.css"; 
 
const StatsCarousel = ({cardData}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const goToNext = () => {
    if (currentIndex < cardData.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <div className="carousel-container">

       <div className="carousel-viewport">
        <div
          className="carousel-film-strip"
          // La magia está aquí: movemos el contenedor por el ancho de UN item a la vez
          style={{ transform: `translateX(-${currentIndex * 25}%)` }}
        >
          {cardData.map((data, index) => (
            <div
              className="carousel-item"
              key={index}
              style={{ flex: `0 0 ${25}%` }}
            >
              <TutoringCard data={data} />
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default StatsCarousel;